// Importing the VCard type from VCardTypes.ts
import { VCard} from '../../../types/ParsedVCardTypes';
import { standardProps } from './config';
import { assignPropertyValue, decodingValueWithMetadata } from './helper';
// @ts-ignore
import { propertyParsers, parseParameters } from './Parsers.ts'
import {
    VERSION,
    VERSION_PROP,
    BEGIN_VCARD,
    END_VCARD
} from '../constants-vcard4';

function parseKeyValue(line : string) {
    let idx = line.indexOf(':');
    if (idx === -1) {
        return {};
    }
    const parameterPart = line.slice(0, idx);
    const value = line.slice(idx + 1);

    // We first split based on semicolons
    let parts = parameterPart.split(';');
    // According to the vCard 4.0 standard, the property name comes before any parameter and is separated by the first semicolon
    const propertyPart = parts.shift();

    // Now we split the property part on "." to extract the group and property name
    const propertyParts = propertyPart.split('.');
    const propName = propertyParts.pop();
    const groupName = propertyParts.length > 0 ? propertyParts.join('.') : null;

    const metadata = parseParameters(parts);

    return {
        group: groupName,
        key: propName,
        value,
        metadata
    };
}

// Add a new function to verify if a property name is a part of the vCard 4.0 standard
function isStandardProp(propertyName : string) {
    return standardProps.includes(propertyName);
}

// VCFParser.js
export const parseVcf: (vcfString: string) => VCard[] = (vcfString) => {
    vcfString = vcfString.replace("\n ", ""); // support continuing long lines (multiple lines)
    let currentCard: Partial<VCard> = {};
    const cards : VCard[] = [];
    // Prepare for multiline properties by removing line break followed by a white space character
    const lines = vcfString.replace(/(\r\n|\n|\r)([ \t])/g, "").split(/\r\n|\n|\r/);
    let isValid = false;

    for (let line of lines) {
        line = line.trim();

        if (line === '' || line.includes(BEGIN_VCARD)) {
            isValid = false;
            continue;
        }

        if (line.includes(END_VCARD)) {
            if (isValid) {
                cards.push({...currentCard} as VCard);
            }
            currentCard = {};
            continue;
        }

        let { group, key, value, metadata } = parseKeyValue(line);
        if (!key || !value || value.trim() === '') continue;

        // Check for vCard version
        if (key.toUpperCase() === VERSION_PROP && value === VERSION) {
            isValid = true;
        }

        if(!isValid) continue;

        const parts = key.split('.');
        const properties = parts[0].split(';');
        const keyLower = properties.shift().toLowerCase();

        value = decodingValueWithMetadata(value, metadata)

        let cardEntry = {
            value: value,
            metadata: metadata
        };
        if (!isStandardProp(keyLower)) {
            currentCard.customProps = {
                ...currentCard.customProps,
                [keyLower]: cardEntry
            };
        } else {
            const parseProperty = propertyParsers[keyLower] || propertyParsers['default'];
            cardEntry = parseProperty(value, metadata);
        }

        if (group) {
            if (!currentCard.groups) {
                currentCard.groups = {};
            }

            currentCard.groups[group] = assignPropertyValue(currentCard.groups[group], keyLower, cardEntry);

        } else {
            currentCard = assignPropertyValue(currentCard, keyLower, cardEntry);
        }
    }

    if (Object.keys(currentCard).length > 0 && isValid) {
        cards.push({...currentCard} as VCard);
    }
    return cards as VCard[];
}